type StatusBadgeVariant =
  | "default"
  | "success"
  | "warning"
  | "danger"
  | "muted"

type StatusBadgeProps = {
  label: string
  variant?: StatusBadgeVariant
}

const variantClasses: Record<StatusBadgeVariant, string> = {
  default: "border-neutral-200 bg-white text-neutral-700",
  success: "border-emerald-200 bg-emerald-50 text-emerald-800",
  warning: "border-amber-200 bg-amber-50 text-amber-800",
  danger: "border-rose-200 bg-rose-50 text-rose-800",
  muted: "border-neutral-200 bg-neutral-50 text-neutral-600",
}

export function StatusBadge({
  label,
  variant = "default",
}: StatusBadgeProps) {
  return (
    <span
      className={`inline-flex items-center rounded-full border px-3 py-1 text-xs font-semibold ${variantClasses[variant]}`}
    >
      {label}
    </span>
  )
}